import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetCashAccounts } from 'api-hooks/cash-account';
import { NavigationRoutes } from 'common/constants';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
interface CashAccountSelectProps extends SelectProps {}

export default function CashAccountSelect(props: CashAccountSelectProps) {
  const { t } = useTranslation();
  const {
    required,
    label = t('common:cash_account'),
    placeholder = t('common:select_cash_account'),
    ...rest
  } = props;
  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.CashMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  const query = useGetCashAccounts({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...rest}
      required={_required}
      data={data}
      label={label}
      placeholder={placeholder}
      disabled={query.isLoading || props.disabled}
    />
  );
}
